<template>
  <div class="container-banners">
    <div class="container-title-box">
      <div class="title-box-title">
        <span>Настройка отображения блока с Новостями и Событиями</span>
        <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false"
          color="var(--app-dark-blue-1)">mdi-information</v-icon>

      </div>
      <div class="title-box-subtitle">
        Выберите ОДИН из вариантов отображения блока на главном экране.
      </div>
      <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
        <v-card min-width="300px" min-height="100px">
          <div class="menu-container">
            <div class="menu-container-title">
              «Новости и события»
            </div>
            <div class="menu-container-text">
              Режим отображения блока на главном экране, в котором отображаются 2 изображения с возможностью перехода в
              новость или событие.
            </div>
            <div class="menu-container-title">
              «Только новости»
            </div>
            <div class="menu-container-text">
              Режим отображения блока на главном экране, в котором отображется 1 большое изображения с возможностью
              перехода в новость.
            </div>
            <div class="menu-container-title">
              «Только события»
            </div>
            <div class="menu-container-text">
              Режим отображения блока на главном экране, в котором отображется 1 большое изображения с возможностью
              перехода в событие.
            </div>
          </div>

        </v-card>
      </v-menu>
    </div>
    <div class="container-banners-buttons">
      <v-btn :outlined="!buttonOne" :class="!buttonOne ? 'button-accept-outlined' : 'button-accept'"
        @click="settingBanner(1)" :color="!buttonOne ? 'var(--app-dark-blue-1)' : ''">
        Новости и события
      </v-btn>
      <v-btn style="margin-left: 24px" :outlined="!buttonTwo"
        :class="!buttonTwo ? 'button-accept-outlined' : 'button-accept'" @click="settingBanner(2)"
        :color="!buttonTwo ? 'var(--app-dark-blue-1)' : ''">
        Только события
      </v-btn>
      <v-btn style="margin-left: 24px" :outlined="!buttonTree"
        :class="!buttonTree ? 'button-accept-outlined' : 'button-accept'" @click="settingBanner(3)"
        :color="!buttonTree ? 'var(--app-dark-blue-1)' : ''">
        Только новости
      </v-btn>
    </div>


    <v-tabs class="container-banners-tabs" color="var(--app-dark-blue-1)">
      <v-tab>
        Новости
      </v-tab>
      <v-tab>
        События

      </v-tab>

      <v-tab-item>
        <div class="banners-tabs-news-table-title">
          <div class="news-table-title-text">
            Выберите новость для отображения ее в слайдере на главном экране.<br> Если хотите создать новость перейдите в
            раздел «Новости» в левом меню
          </div>
          <div>
            <v-btn @click="goToCreateNews" class=" button-accept">
              + Выбрать новость
            </v-btn>
          </div>
        </div>
        <v-data-table :headers="tableHeadersNews" :items="newsBanners" item-key="id" :show-select="false"
          :disable-pagination="true" :hide-default-footer="true">

          <template v-slot:body="props">
            <draggable :list="props.items" tag="tbody" @end="endDrag" :move="checkMove"
              :style="moveItems ? 'pointer-events: none;' : ''">
              <tr v-for="(item, index) in props.items" :key="index" @click="goToDetailNews(item)">
                <td>
                  <v-icon small style="cursor: pointer" :disabled="moveItems ? true : false">
                    mdi-menu
                  </v-icon>
                </td>
                <td style="max-width: 100px !important"> {{ index + 1 }} </td>

                <td v-if="item && item.news">
                  {{ item.news.name }}
                </td>
                <td v-else>
                  -
                </td>


              </tr>
            </draggable>
          </template>

        </v-data-table>


      </v-tab-item>


      <v-tab-item>
        <div class="banners-tabs-news-table-title">
          <div class="news-table-title-text">
            Выберите событие для отображения его в слайдере на главном экране.<br>
            Если хотите создать событие перейдите в раздел «События» в левом меню
          </div>
          <div>
            <v-btn @click="goToCreateEvent" class=" button-accept">
              + Выбрать событие
            </v-btn>
          </div>
        </div>
        <v-data-table :headers="tableHeadersEvents" :items="eventBanners" item-key="id" :show-select="false"
          :disable-pagination="true" :hide-default-footer="true">

          <template v-slot:body="props">
            <draggable :list="props.items" tag="tbody" @end="endDrag" :move="checkMove"
              :style="moveItems ? 'pointer-events: none;' : ''">
              <tr v-for="(item, index) in props.items" :key="index" @click="goToDetailEvents(item)">
                <td>
                  <v-icon small style="cursor: pointer" :disabled="moveItems ? true : false">
                    mdi-menu
                  </v-icon>
                </td>
                <td style="max-width: 100px !important"> {{ index + 1 }} </td>
                <td v-if="item && item.event">
                  {{ item.event.name }}
                </td>
                <td v-else>
                  -
                </td>



              </tr>
            </draggable>
          </template>

        </v-data-table>

      </v-tab-item>
    </v-tabs>

  </div>
</template>
<script>

import draggable from "vuedraggable";
export default {
  components: {
    draggable
  },
  name: "PopUp",
  data: () => ({
    buttonOne: null,
    buttonTwo: null,
    buttonTree: null,
    showInfo: false,
    x: null,
    y: null,
    newsBanners: [],
    eventBanners: [],
    moveItems: false,
    selectedDrag: '',
    tableHeadersNews: [
      {
        text: '',
        sortable: false
      },
      {
        text: 'Порядок отображения ',
        value: '',
        sortable: false
      },
      {
        text: 'Выбранная новость',
        sortable: false,
        value: 'news',
      },

    ],
    tableHeadersEvents: [
      {
        text: '',
        sortable: false
      },
      {
        text: 'Порядок отображения ',
        value: '',
        sortable: false
      },
      {
        text: 'Выбранное событие',
        sortable: false,
        value: 'event',
      },

    ],
    timerId: null,
    newIndexList: [],
  }),
  methods: {
    getStatusBanner() {
      this.$axios.get(this.$store.getters.apiAdminPanelV2 + '/settings/banner', {
        headers: {
          'authorization': this.$store.getters.adminPanelHeaderAuth
        }
      })
        .then(res => {
          if (JSON.stringify(res.data.value) == JSON.stringify(['news', 'events'])) { this.buttonOne = true }
          else if (JSON.stringify(res.data.value) == JSON.stringify(['events'])) { this.buttonTwo = true }
          else if (JSON.stringify(res.data.value) == JSON.stringify(['news'])) { this.buttonTree = true }
        })
        .catch(err => {
          this.$store.commit('errorSet', true)
          this.$store.commit('errorTextSet', err)
        })
    },
    settingBanner(number) {
      let value = null
      if (number == 1) { this.buttonOne = true, value = ['news', 'events'] }
      else if (number == 2) { this.buttonTwo = true, value = ['events'] }
      else if (number == 3) { this.buttonTree = true, value = ['news'] }

      this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/settings/banner', {
        values: value
      }, {
        headers: {
          'authorization': this.$store.getters.adminPanelHeaderAuth
        }
      })
        .then(() => {
        })
        .catch(err => {
          this.$store.commit('errorSet', true)
          this.$store.commit('errorTextSet', err)
        })
    },
    endDrag(evt) {
      this.moveItems = true
      this.$axios.put(this.$store.getters.apiAdminPanelV2 + '/banner/sort', {
        bannerId: this.selectedDrag,
        index: evt.newIndex + 1

      }, {
        headers: {
          'authorization': this.$store.getters.adminPanelHeaderAuth
        }
      })
        .then(() => {

          this.moveItems = false


        })
        .catch(err => {
          this.$store.commit('errorSet', true)
          this.$store.commit('errorTextSet', err)
        })

    },
    checkMove(evt) {
      this.selectedDrag = evt.draggedContext.element.id
    },

    openInfo(e) {

      e.preventDefault()

      this.x = e.clientX + 10
      this.y = e.clientY + 10
      this.showInfo = true
    },

    goToDetailEvents(item) {
      this.$router.push({ name: 'EventsBannerDetail', params: { id: item.id } })
    },
    goToDetailNews(item) {
      this.$router.push({ name: 'NewsBannersDetail', params: { id: item.id } })
    },
    goToCreateNews() {
      this.$router.push({ name: 'NewsBannersCreate' })
    },
    goToCreateEvent() {
      this.$router.push({ name: 'EventsBannerCreate' })
    },
    getNewsBanner() {
      this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/banner/list', {
        type: 'news',
        status: 'active'

      }, {
        headers: {
          'authorization': this.$store.getters.adminPanelHeaderAuth
        }
      })
        .then(res => {

          this.newsBanners = res.data.items

        })
        .catch(err => {
          this.$store.commit('errorSet', true)
          this.$store.commit('errorTextSet', err)
        })


    },
    getEventBanners() {
      this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/banner/list', {
        type: 'events',
        status: 'active'

      }, {
        headers: {
          'authorization': this.$store.getters.adminPanelHeaderAuth
        }
      })
        .then(res => {

          this.eventBanners = res.data.items

        })
        .catch(err => {
          this.$store.commit('errorSet', true)
          this.$store.commit('errorTextSet', err)
        })

    },


  },
  watch: {
    buttonOne() {
      if (this.buttonOne) {
        this.buttonTwo = false
        this.buttonTree = false
      }

    },
    buttonTwo() {
      if (this.buttonTwo) {
        this.buttonOne = false
        this.buttonTree = false
      }
    },
    buttonTree() {
      if (this.buttonTree) {
        this.buttonOne = false
        this.buttonTwo = false
      }
    }

  },
  created() {
    this.getNewsBanner()
    this.getEventBanners()
    this.getStatusBanner()
  }

}
</script>
<style lang="scss" scoped>
.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:not(.v-data-table__mobile-row),
.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>div>tr:not(:last-child)>th:not(.v-data-table__mobile-row) {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.v-data-table>.v-data-table__wrapper>table>tbody>div>tr>td,
.v-data-table>.v-data-table__wrapper>table>thead>tr>td,
.v-data-table>.v-data-table__wrapper>table>tfoot>tr>td {
  font-size: 0.875rem;
  height: 48px;
}

.v-tab {
  text-transform: none;
  font-size: 1rem;
  line-height: 1rem;
  letter-spacing: normal;
  font-weight: 400;

}

.menu-container {
  width: 400px;
  box-sizing: border-box;
  padding: 16px;

  .menu-container-title {
    font-size: 16px;
    font-weight: 600;
    color: #929292;
  }

  .menu-container-text {
    font-size: 16px;
    font-weight: 400;
    width: 330px;
    margin-bottom: 10px;
  }
}

.container-banners {

  .container-title-box {
    box-sizing: border-box;
    padding: 40px 24px 0 24px;

    margin-bottom: 40px;

    .title-box-title {
      display: flex;
      align-items: center;

      span {
        font-size: 28px;
        font-weight: 400;
        margin-right: 20px;

      }

    }

    .title-box-subtitle {
      font-size: 18px;
      font-weight: 400;
      margin-top: 12px;

    }
  }

  .container-banners-buttons {
    display: flex;
    padding: 0px 24px 60px 24px;
  }

  .container-banners-tabs {

    .banners-tabs-news-table-title {
      display: flex;
      justify-content: space-between;
      padding: 24px;

      .news-table-title-text {
        max-width: 650px;
        font-size: 16px;
        font-weight: 400;
        color: #606060;
      }
    }
  }
}
</style>